import Cookies from "js-cookie";

export const AUTH_COOKIE_KEYS = [
  "authToken",
];

// Legacy cookies kept for cleanup only.
const LEGACY_AUTH_COOKIE_KEYS = [
  "userId",
  "username",
  "role",
  "tenant_id",
  "tenant_label",
  "slug",
  "nav_permissions",
];

const AUTH_LOCAL_STORAGE_KEYS = [
  "authToken",
  "userId",
  "username",
  "role",
  "tenant_id",
  "tenant_label",
  "slug",
  "nav_permissions",
  "userData",
];

export const setAuthCookieValue = (key, value, keepSignedIn = true) => {
  if (value === undefined || value === null) return;

  const cookieValue = typeof value === "string" ? value : String(value);
  const options = keepSignedIn ? { expires: 30 } : {};
  Cookies.set(key, cookieValue, options);
};

export const getAuthCookieValue = (key) => {
  const cookieValue = Cookies.get(key);
  if (typeof cookieValue !== "undefined") {
    return cookieValue;
  }
  return localStorage.getItem(key);
};

export const removeAuthCookieValue = (key) => {
  Cookies.remove(key);
  localStorage.removeItem(key);
};

export const clearAuthCookies = () => {
  [...AUTH_COOKIE_KEYS, ...LEGACY_AUTH_COOKIE_KEYS].forEach((key) => {
    Cookies.remove(key);
  });

  AUTH_LOCAL_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
};
